/*
 * Package: WebVideo.Recaptcha
 * Copyright (c) 2017 Oleg Kolychev, Sergey Leonov
 */

function Recaptcha() {}

(function() {
  var onloadName = "Recaptcha_onload_" + new Date().getTime();
  var providerScripts = {
    recaptcha: 'https://www.google.com/recaptcha/api.js?onload=' + onloadName + '&render=explicit',
    turnstile: 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=' + onloadName + '&render=explicit'
  };
  var widgetSelector = '[data-human-verification-role="widget"], .human-verification-widget';
  var defaultErrorMessage = 'Please complete the security check and try again.';

  Recaptcha.getProvider = function() {
    if (typeof Config.humanVerificationProvider !== 'undefined' && Config.humanVerificationProvider.length > 0) {
      return Config.humanVerificationProvider;
    }
    if (typeof Config.checkRecaptchaKey !== 'undefined' && Config.checkRecaptchaKey.length > 0) {
      return 'recaptcha';
    }
    return '';
  };

  Recaptcha.getSiteKey = function(provider) {
    if (provider === 'turnstile') {
      return Config.humanVerificationTurnstileSiteKey || Config.humanVerificationPublicSiteKey || '';
    }
    if (provider === 'recaptcha') {
      return Config.humanVerificationRecaptchaSiteKey || Config.humanVerificationPublicSiteKey || Config.checkRecaptchaKey || '';
    }
    return '';
  };

  Recaptcha.getSelectors = function() {
    var selectors = [];
    if (Config.ContactPage_CheckHumanVerificationCode) selectors.push('form.recaptcha-contact');
    if (Config.CustomerPerson_CheckHumanVerificationCode) selectors.push('form.recaptcha-customer');
    if (Config.PerformerPerson_CheckHumanVerificationCode) selectors.push('form.recaptcha-performer');
    if (Config.WebmasterPerson_CheckHumanVerificationCode) selectors.push('form.recaptcha-webmaster');
    if (Config.ManagerPerson_CheckHumanVerificationCode) selectors.push('form.recaptcha-manager');
    return selectors;
  };

  Recaptcha.providerLoaded = function(provider) {
    if (provider === 'recaptcha') return typeof(grecaptcha) !== 'undefined';
    if (provider === 'turnstile') return typeof(turnstile) !== 'undefined';
    return true;
  };

  Recaptcha.loadProvider = function(provider) {
    if (!providerScripts[provider]) return;
    if (document.querySelector('script[data-human-verification-provider="' + provider + '"]')) return;
    var script = document.createElement('script');
    script.src = providerScripts[provider];
    script.async = true;
    script.defer = true;
    script.setAttribute('data-human-verification-provider', provider);
    document.body.appendChild(script);
  };

  Recaptcha.getMode = function(form) {
    form = $(form);
    var explicitMode = form.attr('data-human-verification-mode');
    if (explicitMode) return explicitMode;
    return form.find(widgetSelector).length > 0 ? 'visible' : 'hidden';
  };

  Recaptcha.getMessageBlock = function(form) {
    form = $(form);
    var block = form.find('.human-verification-message').first();
    if (block.length) return block;
    block = form.find('.result').first();
    if (block.length) return block;
    block = $('<div>', {
      'class': 'human-verification-message',
      'aria-live': 'polite'
    });
    var widget = form.find(widgetSelector).last();
    if (widget.length) {
      widget.after(block);
    } else {
      form.append(block);
    }
    return block;
  };

  Recaptcha.showError = function(form, message) {
    var block = Recaptcha.getMessageBlock(form);
    var text = message || defaultErrorMessage;
    if (block.hasClass('result')) {
      block.html('<p class="warning">' + text + '</p>');
    } else {
      block.text(text);
    }
  };

  Recaptcha.clearError = function(form) {
    var block = Recaptcha.getMessageBlock(form);
    if (block.hasClass('result')) {
      if (block.find('p.warning').length > 0) {
        block.empty();
      }
    } else {
      block.text('');
    }
  };

  Recaptcha.setToken = function(form, token) {
    form = $(form);
    form.data('humanVerificationToken', token || '');
    form.data('humanVerificationTokenAt', (new Date()).getTime());
  };

  Recaptcha.clearToken = function(form) {
    form = $(form);
    form.removeData('humanVerificationToken');
    form.removeData('humanVerificationTokenAt');
    form.find('input[name="cf-turnstile-response"], input[name="g-recaptcha-response"]').remove();
  };

  Recaptcha.hasToken = function(form) {
    form = $(form);
    return !!form.data('humanVerificationToken');
  };

  Recaptcha.disableSubmit = function(form, disabled) {
    $(form).find(':submit').prop('disabled', !!disabled);
  };

  Recaptcha.getMount = function(form) {
    form = $(form);
    var mode = Recaptcha.getMode(form);
    var mount = form.find(widgetSelector).first();
    if (mount.length) return mount;
    if (mode === 'hidden') {
      mount = $('<div>', {
        'class': 'human-verification-widget human-verification-widget-hidden',
        'data-human-verification-role': 'widget',
        'data-human-verification-mode': 'hidden',
        'aria-hidden': 'true'
      }).css({
        position: 'absolute',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)'
      });
      form.append(mount);
    }
    return mount;
  };

  Recaptcha.resetRenderedWidget = function(form) {
    form = $(form);
    var provider = Recaptcha.getProvider();
    var mount = form.find(widgetSelector).first();
    if (!mount.length) return;
    if (provider === 'turnstile' && Recaptcha.providerLoaded(provider) && mount.data('widgetId')) {
      try { turnstile.remove(mount.data('widgetId')); } catch (e) {}
    }
    if (provider === 'recaptcha' && Recaptcha.providerLoaded(provider) && typeof mount.data('widgetId') !== 'undefined') {
      try { grecaptcha.reset(mount.data('widgetId')); } catch (e2) {}
    }
    mount.removeData('widgetId');
    mount.removeData('widgetRendered');
    mount.empty();
    Recaptcha.clearToken(form);
    form.removeData('humanVerificationPendingSubmit');
  };

  Recaptcha.finishAsync = function(form) {
    form = $(form);
    form.removeData('humanVerificationAwaitingAjax');
    form.removeData('humanVerificationPendingSubmit');
    form.removeData('humanVerificationSubmitting');
    Recaptcha.disableSubmit(form, false);
    Recaptcha.resetRenderedWidget(form);
  };

  Recaptcha.renderWidget = function(form) {
    form = $(form);
    var provider = Recaptcha.getProvider();
    var siteKey = Recaptcha.getSiteKey(provider);
    var mount = Recaptcha.getMount(form);
    var mode = Recaptcha.getMode(form);

    if (!siteKey || !provider) return null;
    if (!mount.length) return null;
    if (mount.data('widgetRendered')) return mount;

    var options = {
      sitekey: siteKey,
      callback: function(token) {
        if (!token) {
          Recaptcha.showError(form, defaultErrorMessage);
          return;
        }
        Recaptcha.setToken(form, token);
        Recaptcha.clearError(form);
        if (form.data('humanVerificationPendingSubmit')) {
          Recaptcha.allowSubmit(form);
        }
      }
    };

    if (provider === 'turnstile') {
      var useCompactMobile = mount.attr('data-human-verification-compact-mobile') === 'true' &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(max-width: 767px)').matches;
      options.action = 'human_verification';
      options['error-callback'] = function() {
        Recaptcha.clearToken(form);
        form.removeData('humanVerificationPendingSubmit');
        form.removeData('humanVerificationSubmitting');
        Recaptcha.disableSubmit(form, false);
        Recaptcha.showError(form, defaultErrorMessage);
      };
      options['expired-callback'] = function() {
        Recaptcha.clearToken(form);
        form.removeData('humanVerificationPendingSubmit');
        form.removeData('humanVerificationSubmitting');
        Recaptcha.disableSubmit(form, false);
        Recaptcha.showError(form, defaultErrorMessage);
      };
      options.size = mode === 'visible' ? (useCompactMobile ? 'compact' : 'flexible') : 'invisible';
      mount.data('widgetId', turnstile.render(mount.get(0), options));
    } else if (provider === 'recaptcha') {
      options.size = mode === 'visible' ? 'normal' : 'invisible';
      options['expired-callback'] = function() {
        Recaptcha.clearToken(form);
        form.removeData('humanVerificationPendingSubmit');
        form.removeData('humanVerificationSubmitting');
        Recaptcha.disableSubmit(form, false);
        Recaptcha.showError(form, defaultErrorMessage);
      };
      options['error-callback'] = function() {
        Recaptcha.clearToken(form);
        form.removeData('humanVerificationPendingSubmit');
        form.removeData('humanVerificationSubmitting');
        Recaptcha.disableSubmit(form, false);
        Recaptcha.showError(form, defaultErrorMessage);
      };
      mount.data('widgetId', grecaptcha.render(mount.get(0), options));
    }

    mount.data('widgetRendered', true);
    return mount;
  };

  Recaptcha.executeHidden = function(form) {
    form = $(form);
    var provider = Recaptcha.getProvider();
    var mount = Recaptcha.renderWidget(form);
    if (!mount || !mount.length || typeof mount.data('widgetId') === 'undefined') {
      Recaptcha.showError(form, defaultErrorMessage);
      form.removeData('humanVerificationPendingSubmit');
      form.removeData('humanVerificationSubmitting');
      Recaptcha.disableSubmit(form, false);
      return false;
    }
    Recaptcha.clearToken(form);
    if (provider === 'turnstile') {
      try {
        turnstile.reset(mount.data('widgetId'));
        turnstile.execute(mount.data('widgetId'));
      } catch (e) {
        Recaptcha.showError(form, defaultErrorMessage);
        form.removeData('humanVerificationPendingSubmit');
        form.removeData('humanVerificationSubmitting');
        Recaptcha.disableSubmit(form, false);
        return false;
      }
      return true;
    }
    if (provider === 'recaptcha') {
      try {
        grecaptcha.reset(mount.data('widgetId'));
        grecaptcha.execute(mount.data('widgetId'));
      } catch (e2) {
        Recaptcha.showError(form, defaultErrorMessage);
        form.removeData('humanVerificationPendingSubmit');
        form.removeData('humanVerificationSubmitting');
        Recaptcha.disableSubmit(form, false);
        return false;
      }
      return true;
    }
    return false;
  };

  Recaptcha.allowSubmit = function(form) {
    form = $(form);
    var domForm = form.get(0);
    if (!Recaptcha.hasToken(form)) {
      form.removeData('humanVerificationPendingSubmit');
      form.removeData('humanVerificationSubmitting');
      Recaptcha.disableSubmit(form, false);
      Recaptcha.showError(form, defaultErrorMessage);
      return false;
    }

    Recaptcha.clearError(form);
    form.removeData('humanVerificationPendingSubmit');

    var originalSubmit = form.data('humanVerificationOriginalSubmit');
    if (typeof originalSubmit === 'function') {
      var submitResult = originalSubmit.call(domForm);
      if (submitResult === false) {
        form.data('humanVerificationAwaitingAjax', true);
        return false;
      }
    }

    form.removeData('humanVerificationSubmitting');
    form.data('humanVerificationBypassOnce', true);
    if (domForm && typeof domForm.submit === 'function') {
      domForm.submit();
      return true;
    }
    form.trigger('submit');
    return true;
  };

  Recaptcha.bindForm = function(form) {
    form = $(form);
    if (form.hasClass('recaptcha-inited')) return;

    var domForm = form.get(0);
    if (domForm && domForm.onsubmit) {
      form.data('humanVerificationOriginalSubmit', domForm.onsubmit);
      domForm.onsubmit = null;
      form.removeAttr('onsubmit');
    }

    form.on('submit.recaptcha', function(ev) {
      var currentForm = $(this);
      if (currentForm.data('humanVerificationBypassOnce')) {
        currentForm.removeData('humanVerificationBypassOnce');
        return true;
      }

      ev.preventDefault();
      ev.stopImmediatePropagation();

      if (currentForm.data('humanVerificationSubmitting')) {
        return false;
      }

      currentForm.data('humanVerificationSubmitting', true);
      Recaptcha.disableSubmit(currentForm, true);
      Recaptcha.clearError(currentForm);

      var provider = Recaptcha.getProvider();
      if (!Recaptcha.providerLoaded(provider)) {
        Recaptcha.loadProvider(provider);
        currentForm.removeData('humanVerificationSubmitting');
        Recaptcha.disableSubmit(currentForm, false);
        Recaptcha.showError(currentForm, defaultErrorMessage);
        return false;
      }

      if (Recaptcha.getMode(currentForm) === 'visible') {
        var mount = Recaptcha.getMount(currentForm);
        if (!mount.length) {
          currentForm.removeData('humanVerificationSubmitting');
          Recaptcha.disableSubmit(currentForm, false);
          Recaptcha.showError(currentForm, defaultErrorMessage);
          return false;
        }
        Recaptcha.renderWidget(currentForm);
        if (!Recaptcha.hasToken(currentForm)) {
          currentForm.removeData('humanVerificationSubmitting');
          Recaptcha.disableSubmit(currentForm, false);
          Recaptcha.showError(currentForm, defaultErrorMessage);
          return false;
        }
        return Recaptcha.allowSubmit(currentForm);
      }

      currentForm.data('humanVerificationPendingSubmit', true);
      return Recaptcha.executeHidden(currentForm);
    });

    form.addClass('recaptcha-inited');
  };

  Recaptcha.init = function(container) {
    var provider = Recaptcha.getProvider();
    var siteKey = Recaptcha.getSiteKey(provider);
    if (provider.length === 0 || siteKey.length === 0) return;

    var selectors = Recaptcha.getSelectors();
    if (selectors.length === 0) return;

    var forms = $(selectors.join(), container);
    if (forms.length === 0) return;

    forms.each(function() {
      Recaptcha.bindForm(this);
    });

    if (!Recaptcha.providerLoaded(provider)) {
      Recaptcha.loadProvider(provider);
    } else {
      window[onloadName]();
    }
  };

  window[onloadName] = function() {
    var selectors = Recaptcha.getSelectors();
    if (selectors.length === 0) return;
    $(selectors.join()).each(function() {
      var form = $(this);
      if (Recaptcha.getMode(form) === 'visible') {
        try {
          Recaptcha.renderWidget(form);
        } catch (e) {
          Recaptcha.showError(form, defaultErrorMessage);
        }
      }
    });
  };

  $(document).ajaxComplete(function(_event, _xhr, settings) {
    var url = settings && settings.url ? settings.url : '';
    $('form.recaptcha').each(function() {
      var form = $(this);
      if (!form.data('humanVerificationAwaitingAjax')) return;
      var action = form.attr('action') || '';
      if (url.indexOf('_ajaj-webvideo-gateway.jsp') !== -1 || (action && url.indexOf(action) !== -1)) {
        Recaptcha.finishAsync(form);
      }
    });
  });
})();

$(function() {
  Recaptcha.init();
});
